var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C4.39687 12 2.88984 11.3766 1.75781 10.2422C0.623437 9.11016 0 7.60313 0 6C0 4.39687 0.623437 2.88984 1.75781 1.75781C2.89219 0.625781 4.39687 0 6 0C7.60313 0 9.11016 0.623437 10.2422 1.75781C11.3766 2.89219 12 4.39687 12 6C12 7.60313 11.3766 9.11016 10.2422 10.2422C9.10781 11.3742 7.60313 12 6 12ZM6 0.970313C3.225 0.970313 0.970313 3.225 0.970313 6C0.970313 8.775 3.225 11.0297 6 11.0297C8.775 11.0297 11.0297 8.775 11.0297 6C11.0297 3.225 8.775 0.970313 6 0.970313Z",
    fill: "#9CA0AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65469 8.13985C7.53047 8.13985 7.40625 8.09298 7.3125 7.99688L5.65782 6.34219C5.56641 6.25079 5.51485 6.12891 5.51485 6.00001V2.69063C5.51485 2.42344 5.73282 2.20547 6 2.20547C6.26719 2.20547 6.48516 2.42344 6.48516 2.69063V5.79844L7.99688 7.31016C8.18672 7.50001 8.18672 7.80704 7.99688 7.99454C7.90313 8.09298 7.77891 8.13985 7.65469 8.13985Z",
    fill: "#9CA0AA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clock.b553215edb2137491ac2684919e4497f.svg";